import { render } from "./ClientHeader.vue?vue&type=template&id=22e8f9b8"
import script from "./ClientHeader.vue?vue&type=script&lang=js"
export * from "./ClientHeader.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__